import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey5 } from 'approot/shared/styles/colours.style';
import {
  spacing12,
  spacing16,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { PStyled } from 'approot/shared/styles/typography.style';
import {
  BaseAutosuggestStylesProps,
  baseAutosuggestStyles,
} from 'approot/shared/styles/autosuggest.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';

export const LessonMaterialsRow = styled(Box).attrs(props => ({
  $gap: spacing8,
  $alignItems: props.$alignItems || 'center',
}))`
  flex-wrap: nowrap;
  width: 100%;
`;

export const LessonMaterialsItemInner = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const LessonMaterialsItem = styled.div`
  border: 1px solid ${grey5};
  padding: ${rem(spacing12)};
  border-radius: ${rem(borderRadius8)};
  margin-bottom: ${rem(spacing16)};

  ${LessonMaterialsItemInner} {
    margin-bottom: ${rem(spacing16)};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const LessonMaterialsTextAreaWrapper = styled.div`
  width: 100%;
`;

export const LessonMaterialsGroupLabel = styled(PStyled)`
  margin-bottom: 0;
`;

export const LessonMaterialsAutoSuggest = styled.div<BaseAutosuggestStylesProps>`
  position: relative;
  width: 100%;

  ${baseAutosuggestStyles}
`;

export const LessonMaterialsPill = styled(SecondaryButton)`
  min-height: ${rem(32)};
  height: auto;
  text-align: left;
  white-space: wrap;
`;

export const LessonMaterialSearchInfo = styled(PStyled)`
  margin: ${rem(spacing16)};
`;
